import React, { useEffect, useState, useRef } from 'react'
import { Box, Flex, Group, Grid, Button, Tabs, TextInput, Select, SimpleGrid, ActionIcon, NumberInput, MultiSelect, Input, Text, Paper, Image, Checkbox } from '@mantine/core'
import { DateInput, TimeInput } from '@mantine/dates'
import { Dropzone } from '@mantine/dropzone'
import { IconClock, IconPhotoPlus } from '@tabler/icons-react'
import LoadingData from '../../ui/LoadingData'
import NoImage from '../../../assets/img/images/no-images.png'
import { getAllCountryList } from '../../../services/location'
import { getListUserMemberships } from '../../../services/users'
import { getCategorysList } from '../../../services/category'
import { addCustomMenu, updateCustomMenu, updateImageCustomMenu } from '../../../services/custom-menu'
import { useDebouncedCallback } from '@mantine/hooks'
import dayjs from 'dayjs'
import { useNavigate } from 'react-router-dom'
import { validation } from '../../../plugins/validation'
import { notificationSuccess, notificationError } from '../../ui/Notifications'

const defaultMenuType = [
  {
    label: 'Article',
    value: 'article'
  },
  {
    label: 'Video',
    value: 'video'
  },
  {
    label: 'Event',
    value: 'event'
  },
  {
    label: 'Tutorial',
    value: 'tutorial'
  },
]

const defaultVal = {
  menu_name: '',
  menu_type: '',
  action_type: 'url',
  custom_url: '',
  category: null,
  priority: '',
  event_date: new Date(),
  event_time: '00:00',
  event_location: '',
  event_admission: '',
  status: 'active',
  countries: [],
  specific_membership: [],
  is_agent: false,
}

const formValidation = {
  menu_name: {
    isError: false,
    message: ''
  },
  menu_type: {
    isError: false,
    message: ''
  },
  action_type: {
    isError: false,
    message: ''
  },
  custom_url: {
    isError: false,
    message: ''
  },
  category: {
    isError: false,
    message: ''
  },
  priority: {
    isError: false,
    message: ''
  },
  event_date: {
    isError: false,
    message: ''
  },
  event_time: {
    isError: false,
    message: ''
  },
  event_location: {
    isError: false,
    message: ''
  },
  event_admission: {
    isError: false,
    message: ''
  },
  image: {
    isError: false,
    message: ''
  }
}

const FormCustomMenu = ({ dataMenu, onCloseForm, reloadList }) => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(true)
  const [loadingForm, setLoadingForm] = useState(false)
  const [selectedTab, setSelectedTab] = useState('form')
  const timeRef = useRef(null)

  const [formData, setFormData] = useState(defaultVal)
  const [validationForm, setValidationForm] = useState(formValidation)

  const [imageUpload, setImageUpload] = useState(null)
  const [imageFile, setImageFile] = useState(null)
  const [recentImage, setRecentImage] = useState(null)

  const [countryList, setCountryList] = useState([])
  const [userRoleList, setUserRoleList] = useState([])
  const [categoryList, setCategoryList] = useState([])

  const submitCustomMenu = async (form) => {
    setLoadingForm(true)
    setValidationForm(formValidation)
    let methodFunction = null
    let titleMessageSuccess = ''
    let captionMessageSuccess = ''
    let titleMessageError = ''
    let captionMessageError = ''

    const validateForm = {
      menu_name: form.menu_name,
      menu_type: form.menu_type,
      action_type: 'url',
      custom_url: form.custom_url,
      category: form.category,
      priority: `${form.priority}`,
    }

    if (form.menu_type === 'event') {
      validateForm.event_date = form.event_date
      validateForm.event_time = form.event_time
      validateForm.event_location = form.event_location
      validateForm.event_admission = form.event_admission
    } else {
      delete validateForm.event_date
      delete validateForm.event_time
      delete validateForm.event_location
      delete validateForm.event_admission
    }

    const isError = validation(validateForm, setValidationForm)
    if (isError) {
      setLoadingForm(false)
      return
    }
    if (dataMenu === null) {
      if (imageFile === null) {
        setLoadingForm(false)
        setSelectedTab('poster')
        setValidationForm((oldVal) => (
          {
            ...oldVal,
            image: {
              isError: true,
              message: 'poster is required'
            }
          }
        ))
        notificationError('Submit Custom Menu Failed', 'Please insert poster')
        return
      }
    }

    const findCategory = categoryList.find(
      (val) => val.value === form.category
    );

    const payloadForm = {
      menu_name: form.menu_name,
      menu_type: form.menu_type,
      action_type: form.action_type,
      custom_url: form.custom_url,

      category_id: findCategory?.id ?? null,
      category: findCategory?.label ?? null,

      priority: form.priority,
      status: form.status,

      is_agent: form.is_agent ? 1 : 0,

      ...(form.menu_type === 'event' && {
        event_date: `${dayjs(form.event_date).format('YYYY-MM-DD')} ${form.event_time}:00`,
        event_time: `${form.event_time}:00`,
        event_location: form.event_location,
        event_admission: form.event_admission,
      }),
      ...(imageUpload && { image_encoded: imageUpload }),

      countries: form.countries.length > 0 ? form.countries.map(e => +e) : [],
      exclude_country: form.exclude_country.length > 0 ? form.exclude_country.map(e => +e) : [],
      specific_membership: form.specific_membership.length > 0 ? form.specific_membership.map(e => +e) : [],
    }

    if (dataMenu !== null) {
      methodFunction = updateCustomMenu(dataMenu.id, payloadForm)
      titleMessageSuccess = 'Update Custom Menu Successfully'
      captionMessageSuccess = 'You have been updated data custom menu'
      titleMessageError = 'Update Custom Menu Error'
    } else {
      methodFunction = addCustomMenu(payloadForm)
      titleMessageSuccess = 'Add Custom Menu Successfully'
      captionMessageSuccess = 'You have been added new custom menu'
      titleMessageError = 'Add Custom Menu Error'
    }
    try {
      const response = await methodFunction
      if (response.success) {
        notificationSuccess(titleMessageSuccess, captionMessageSuccess)
        onCloseForm()
        reloadList()
      } else {
        const responseMessage = response.message
        notificationError(titleMessageError, responseMessage)
      }
    } catch (error) {
      const errorMessage = error.response.data.message
      captionMessageError = Object.keys(errorMessage) ? errorMessage : 'Please recheck your form'
      notificationError(titleMessageError, captionMessageError)
    } finally {
      setLoadingForm(false)
    }
  }

  const handleGetListCountry = useDebouncedCallback(async () => {
    const parameter = {
      'page[num]': 1,
      'page[limit]': 9999,
      'fields[country]': 'name',
    }
    try {
      const response = await getAllCountryList(parameter)
      const dataCountry = response.data
      const remapDataCountry = dataCountry.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setCountryList(remapDataCountry)
    } catch (error) {
      console.log(error)
    }
  }, 300)

  const handleGetListUserRole = useDebouncedCallback(async () => {
    const parameter = {
      'page[num]': 1,
      'page[limit]': 100,
      'fields[supplier]': 'name',
    }
    try {
      const response = await getListUserMemberships(parameter)
      const dataUserRoles = response.data.data
      const remapDataUserRoles = dataUserRoles.map((val) => {
        return {
          value: `${val.attributes.id}`,
          label: val.attributes.name
        }
      })
      setUserRoleList(remapDataUserRoles)
    } catch (error) {
      console.log(error)
    }
  }, 300)

  const handleGetListCategory = useDebouncedCallback(async () => {
    const parameter = {
      'page[num]': 1,
      'page[limit]': 100,
      'filter[category_type][is]': 2,
    }
    try {
      const response = await getCategorysList(parameter)
      const dataCategory = response.data.data
      const remapDataCategory = dataCategory.map((val) => {
        return {
          id: val.attributes.id,
          value: val.attributes.name,
          label: val.attributes.name
        }
      })
      setCategoryList(remapDataCategory)
    } catch (error) {
      console.log(error)
    }
  }, 300)

  const handlingLoadData = async () => {
    setLoading(true)
    try {
      await handleGetListCategory()
      await handleGetListCountry()
      await handleGetListUserRole()
    } catch (error) {
      console.log(error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    handlingLoadData()
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (dataMenu !== null) {
      handleSetForm(dataMenu)
    }
  }, [dataMenu])

  const handleSetForm = (value) => {
    const detail = {
      menu_name: value.menu_name,
      menu_type: value.menu_type,
      custom_url: value.custom_url,
      action_type: 'url',
      category: value.category,
      priority: value.priority,
      countries: value.countries ? value.countries.map(String) : [],
      specific_membership: value.specific_membership ? value.specific_membership.map(String) : [],
      event_date: value.event_date !== null ? new Date(value.event_date) : null,
      event_time: value.event_time !== null ? value.event_time : null,
      event_location: value.event_location !== null ? value.event_location : '',
      event_admission: value.event_admission !== null ? value.event_admission : '',
      status: value.status ? (typeof value.status === 'object' ? value.status.value : value.status.toLowerCase()) : 'active',
      is_agent: value.is_agent ? true : false,
      exclude_country: value.exclude_country ? value.exclude_country.map(String) : [],
    }
    if (value.image_url) {
      setRecentImage(value.image_url)
    }
    setFormData(detail)
  }

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val }))
  }

  const handleSelectedImage = () => {
    return imageUpload || recentImage || NoImage
  }

  const pickerControl = () => {
    return (
      <ActionIcon variant="subtle" color="gray" onClick={() => timeRef.current?.showPicker()}>
        <IconClock size={16} stroke={1.5} />
      </ActionIcon>
    )
  }

  const handleUploadImage = (file) => {
    setValidationForm(formValidation)
    const fileEncoded = file[0]
    const fileReader = new FileReader()
    fileReader.readAsDataURL(fileEncoded)
    fileReader.onload = (reader) => {
      setImageUpload(reader.target.result)
      setImageFile(fileEncoded)
    }
  }

  const handleErrorFile = (file) => {
    setValidationForm(formValidation)
    const fileState = Object.values(file)
    const errorMessage = fileState[0].errors[0].message
    if (errorMessage) {
      const error = {

        image: {
          isError: true,
          message: errorMessage
        }
      }
      setValidationForm(error)
    }
  }

  const handlingValidation = (val) => {
    if (val === 'event') {
      setValidationForm(formValidation)
    } else {
      delete validationForm.event_date
      delete validationForm.event_time
      delete validationForm.event_location
      delete validationForm.event_admission
    }
  }

  const loadFormCustomMenu = () => {

    const mappingFormEvent = (typeMenu) => {
      if (typeMenu === 'event') {
        return (
          <SimpleGrid cols={2} verticalSpacing="sm" mb='sm'>
            <Box>
              <DateInput
                valueFormat="DD/MM/YYYY"
                value={formData.event_date}
                onChange={(val) => handleChangeForm('event_date', val)}
                error={validationForm.event_date.isError ? `${validationForm.event_date.message}` : ''}
                label="Event Date"
                placeholder="Date input"
                clearable
                size='xs'
                withAsterisk
              />
            </Box>
            <Box>
              <TimeInput
                ref={timeRef}
                name='event_time'
                value={formData.event_time}
                label='Event Time'
                onChange={(val) => handleChangeForm('event_time', val.currentTarget.value)}
                rightSection={pickerControl()}
                error={validationForm.event_time.isError ? `${validationForm.event_time.message}` : ''}
                size='xs'
                clearable
                withAsterisk
              />
            </Box>
            <Box>
              <TextInput
                name='event_location'
                value={formData.event_location}
                label='Event Location'
                error={validationForm.event_location.isError ? `${validationForm.event_location.message}` : ''}
                onChange={(val) => handleChangeForm('event_location', val.target.value)}
                withAsterisk
                size='xs'
              />
            </Box>
            <Box>
              <TextInput
                name='event_admission'
                value={formData.event_admission}
                label='Event Admission'
                error={validationForm.event_admission.isError ? `${validationForm.event_admission.message}` : ''}
                onChange={(val) => handleChangeForm('event_admission', val.target.value)}
                withAsterisk
                size='xs'
              />
            </Box>
          </SimpleGrid>
        )
      }
    }

    return (
      <Box>
        <Box mih={550}>
          <Tabs size='xs' my={4} value={selectedTab} onChange={setSelectedTab}>
            <Tabs.List>
              <Tabs.Tab value="form">Custom Menu</Tabs.Tab>
              <Tabs.Tab value="poster">Poster</Tabs.Tab>
            </Tabs.List>
            <Tabs.Panel value="form">
              <Box my={10}>
                <Box mb='sm'>
                  <Grid mt='sm'>
                    <Grid.Col span={6}>
                      <TextInput
                        name='menu_name'
                        value={formData.menu_name}
                        label='Menu Name'
                        error={validationForm.menu_name.isError ? `${validationForm.menu_name.message}` : ''}
                        onChange={(val) => handleChangeForm('menu_name', val.target.value)}
                        withAsterisk
                        size='xs'
                      />
                    </Grid.Col>
                    <Grid.Col span={6}>
                      <Select
                        name='menu_type'
                        value={formData.menu_type}
                        label='Menu Type'
                        data={defaultMenuType}
                        onChange={(val) => [handleChangeForm('menu_type', val), handlingValidation(val)]}
                        error={validationForm.menu_type.isError ? `${validationForm.menu_type.message}` : ''}
                        size='xs'
                        allowDeselect={false}
                        withAsterisk
                      />
                    </Grid.Col>
                  </Grid>
                </Box>
                <Box mb='sm'>
                  {mappingFormEvent(formData.menu_type)}
                </Box>
                <Box mb='sm'>
                  <TextInput
                    name='custom_url'
                    value={formData.custom_url}
                    label='URL'
                    error={validationForm.custom_url.isError ? `${validationForm.custom_url.message}` : ''}
                    onChange={(val) => handleChangeForm('custom_url', val.target.value)}
                    withAsterisk
                    size='xs'
                  />
                </Box>
                <Box mb='sm'>
                  <Select
                    name='category'
                    value={formData.category}
                    label='Category'
                    description={<Text fz='xs'>You can add new category <Text component='span' fz='xs' c='blue.9' onClick={() => navigate('/promotions/custom-menu-categories')} style={{ cursor: 'pointer' }}>here</Text></Text>}
                    data={categoryList}
                    onChange={(val) => handleChangeForm('category', val)}
                    error={validationForm.category.isError ? `${validationForm.category.message}` : ''}
                    size='xs'
                    clearable
                    withAsterisk
                  />
                </Box>
                <Box mb='sm'>
                  <Grid>
                    <Grid.Col span={6}>
                      <Select
                        name='status'
                        value={formData.status}
                        label='Status'
                        data={[
                          { label: 'Active', value: 'active' },
                          { label: 'Inactive', value: 'inactive' }
                        ]}
                        onChange={(val) => handleChangeForm('status', val)}
                        size='xs'
                        withAsterisk
                        allowDeselect={false}
                      />
                    </Grid.Col>
                    <Grid.Col span={6}>
                      <NumberInput
                        label="Priority Number"
                        value={formData.priority}
                        onChange={(val) => handleChangeForm('priority', val)}
                        error={validationForm.priority.isError ? `${validationForm.priority.message}` : ''}
                        size='xs'
                        withAsterisk
                      />
                    </Grid.Col>

                  </Grid>
                </Box>
                <Box mb='sm'>
                  <Grid>
                    <Grid.Col span={6}>
                      <MultiSelect
                        name='countries'
                        value={formData.countries}
                        label='Country Sign Up User'
                        data={countryList}
                        onChange={(val) => handleChangeForm('countries', val)}
                        size='xs'
                        clearable
                        searchable
                      />
                    </Grid.Col>
                    <Grid.Col span={6}>
                      <MultiSelect
                        name='exclude_country'
                        value={formData.exclude_country}
                        label='Exclude Country Sign Up User'
                        data={countryList}
                        onChange={(val) => handleChangeForm('exclude_country', val)}
                        size='xs'
                        clearable
                        searchable
                      />
                    </Grid.Col>
                  </Grid>
                </Box>
                <Grid align="flex-end" mb='sm'>
                  <Grid.Col span={6}>
                    <MultiSelect
                      name='specific_membership'
                      value={formData.specific_membership}
                      label='Show to Specific Role'
                      data={userRoleList}
                      onChange={(val) => handleChangeForm('specific_membership', val)}
                      size='xs'
                      clearable
                      searchable
                    />
                  </Grid.Col>
                  <Grid.Col span={6}>
                    <Box pb={8}>
                      <Checkbox
                        label="show only for Agent"
                        checked={formData.is_agent}
                        onChange={(val) => handleChangeForm('is_agent', val.target.checked)}
                        size='xs'
                      />
                    </Box>
                  </Grid.Col>
                </Grid>
              </Box>
            </Tabs.Panel>
            <Tabs.Panel value="poster">
              <Box my={10}>
                <Box mb={20}>
                  <Input.Wrapper
                    label='Upload Poster Custom Menu'
                    size='xs'
                    withAsterisk
                    error={validationForm.image.isError ? `${validationForm.image.message}` : ''}
                  >
                    <Box my={10}>
                      <Dropzone
                        accept={[
                          'image/png',
                          'image/jpeg',
                          'image/gif',
                        ]}
                        onDrop={(files) => handleUploadImage(files)}
                        onReject={(files) => handleErrorFile(files)}
                        maxSize={2000000}
                      >
                        <Box ta='center' my={15}>
                          <Flex justify='center' mb={10}>
                            <IconPhotoPlus size={50} color='gray' />
                          </Flex>
                          <Box>
                            <Text fz={12} c='blue.9'>Upload Image Here</Text>
                            <Text fz={12} c='gray.6'>PNG, JPG, GIF up to 2 MB</Text>
                          </Box>
                        </Box>
                      </Dropzone>
                    </Box>
                  </Input.Wrapper>
                </Box>
                <Box>
                  <Text fz={12} fw='500' mb={10}>Recent / Review Poster</Text>
                  <Paper shadow="sm" withBorder radius='md' style={{ backgroundColor: '#f1f2f5' }}>
                    <Flex justify='center'>
                      <Image src={handleSelectedImage()} w='auto' radius='md' h={250} fit='contain' />
                    </Flex>
                  </Paper>
                </Box>
              </Box>
            </Tabs.Panel>
          </Tabs>
        </Box>
        <Box mt={20}>
          <Flex justify='flex-end'>
            <Group>
              <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
              <Button size='xs' loading={loadingForm} variant="filled" onClick={() => submitCustomMenu(formData)}>{dataMenu !== null ? 'Update' : 'Create'}</Button>
            </Group>
          </Flex>
        </Box>
      </Box>
    )
  }

  return (
    <Box>
      {loading ? <LoadingData /> : loadFormCustomMenu()}
    </Box>
  )
}

export default FormCustomMenu